function verifyCI(ci) {
  if (ci && ci.length > 6) {
    ci = ci.replace(/\D/g, '');
    var dig = parseInt(ci[ci.length - 1]);
    ci = ci.replace(/[0-9]$/, '');

    var a = 0;
    var i = 0;
    if (ci.length === 6) {
      for (i = ci.length; i < 7; i++) {
        ci = '0' + ci;
      }
    }

    for (i = 0; i < 7; i++) {
      a += (parseInt("2987634"[i]) * parseInt(ci[i])) % 10;
    }

    if (a % 10 === 0) {
      return dig === 0;
    } else {
      return dig === (10 - a % 10);
    }
  }
  return false;
}

function verifyPhone(phone) {
  if (phone) {
    const firstDigit = parseInt(phone[0])
    const secondDigit = parseInt(phone[1])
    if (phone.length === 8) {
      // teléfono fijo o celular 
      return firstDigit === 2 || firstDigit === 4 || firstDigit === 9;
    } else if (phone.length === 9) {
      // celular
      return firstDigit === 0 && secondDigit === 9;
    }
  }
  return false;
}


export { verifyCI, verifyPhone }